export interface BaseColumnConfig {
  title: string;
  dataClasses?: string[];
  columnClasses?: string[];
  sortConfig?: SortConfig;
}

export interface SlotColumnConfig extends BaseColumnConfig {
  slotName: string;
}

export function isSlotColumnConfig(
  colConf: ColumnConfig
): colConf is SlotColumnConfig {
  return (colConf as SlotColumnConfig).slotName !== undefined;
}

export interface PropertyColumnConfig extends BaseColumnConfig {
  propertyName: string;
}

export function isPropertyColumnConfig(
  colConf: ColumnConfig
): colConf is PropertyColumnConfig {
  return (colConf as PropertyColumnConfig).propertyName !== undefined;
}

export type ColumnConfig = SlotColumnConfig | PropertyColumnConfig;

export interface SortConfig {
  sortable: boolean;
}
